module.exports = __webpack_public_path__ + "img/487.a7abf3f9.png";